<template>
  <div>
    <div class="clear"></div>
    <!-- Content
    =============================================-->
    <section id="content">
      <div class="content-wrap">
        <div class="container clearfix">
          <!-- Page Title
          =============================================-->
          <!-- <section id="page-title">
            <div class="container clearfix">
              <h1>วิธีเช่าชุด</h1>
            </div>
          </section>-->
          <div class="faq_title">
            คำถามที่พบบ่อย
          </div>
          <!-- #page-title end -->

          <!-- Post Content
          =============================================-->
          <div class="row">
            <div
              class="postcontent nobottommargin clearfix"
              style="max-width:1150px; !important; margin-left: auto; margin-right: auto;"
            >
              <div id="faqs" class="faqs">
                <div class="toggle faq faq-marketplace faq-authors">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-question-alt"></i>1.
                    ร้านเช่าชุดอยู่ที่ไหนคะ?
                  </div>
                  <div class="togglec">
                    ให้เสิร์ชว่า "ตลาดพูนทรัพย์ปทุมธานี/หรือ Poonsup market" ค่ะ
                    <br />
                    ร้านจะอยู่ตรงข้าม Cafe Amazon ทางออกตลาด <br />
                    หน้าร้านจะมีผ้าใบสีชมพูเป็นประตูกระจก <br />
                    ถึงแล้วสามารถโทรหาแอดมินได้ค่ะ
                    <br/>
                    083-403-0124
                    <!-- <br />084-923-9292(แอดมินอาย) , <br />098-475-3520 (แอดมินนิ
                    ), <br />097-921-0943 (แอดมินจอย) -->
                  </div>
                </div>

                <div class="toggle faq faq-authors faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>2.
                    ขั้นตอนในการจองผ่านเว็บไซด์ วางแผนการรับชุดอย่างไร?
                  </div>
                  <div class="togglec">
                    ทางร้านกำหนดให้เช่าชุด 3 วัน ต่อการเช่า 1 ครั้ง <br />
                    เช่น ลูกค้าอยู่ต่างจังหวัด ต้องการจัดส่งโดย Kerry <br />
                    คุณลูกค้าต้องการใช้ชุดวันที่ 5 มกราคม <br />
                    (รบกวนโอนชำระและแจ้งล่วงหน้าก่อน 2-3 วัน ที่ต้องการเช่าชุด)
                    <br />
                    คุณลูกค้าต้องชำระไม่เกินวันที่ 1 มกราคม <br />
                    ร้านแพ๊คจัดส่งภายในวันที่ 2 (ต่างจังหวัด 2-3 วัน , กทม. 1-2
                    วัน ถึงลูกค้าค่ะ ) <br />
                    การจัดส่งคืนลูกค้าจัดส่งคืนไม่เกินวันที่ 8 มกราคม ค่ะ
                  </div>
                </div>

                <div class="toggle faq faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>3. เช่าแค่ 1
                    วัน ลดได้มั้ยคะ ?
                  </div>
                  <div class="togglec">
                    # สำหรับการเช่า 1 วัน ได้ส่วนลด 20% จากราคาค่าเช่า 3 วัน
                    <br />
                    เงื่อนไข <br />
                    - ต้องส่งจัดส่งโดยแมส ทั้งไปและกลับเท่านั้น<br />
                    - เช่าวันนี้ คืนวันถัดไป โดยแมสเซนเจอร์เท่านั้น<br />
                    - คืนช้ากว่ากำหนดหรือไม่คืนทางแมสเซนเจอร์ มีค่าปรับค่ะ<br />
                  </div>
                </div>

                <div
                  class="toggle faq faq-authors faq-legal faq-itemdiscussion"
                >
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>4.
                    อยากลองชุดแต่ไม่สะดวกเดินทางมาที่ร้าน
                    ส่งชุดให้ลองโดยแมสได้มั้ยคะ ?
                  </div>
                  <div class="togglec">
                    👉🏻 มีหน้าร้านให้ลูกค้าลองได้นะคะ <br />
                    ถ้าไม่สะดวกส่งแมสได้ค่ะ 😍 <br />
                    ❤️ สามารถมาลองที่ตลาดพูนทรัพย์ ปทุมธานีได้ <br />
                    ❤️ ทางร้านสามารถส่งให้ลองได้ค่ะ <br />
                    <span style="padding-left: 30px;"
                      >👄 โดยลูกค้าต้องรับผิดชอบค่าแมสไปกลับเอง
                    </span>
                    <br />
                    <span style="padding-left: 30px;">
                      👄 วางเงินประกันก่อนส่งให้ลอง
                    </span>
                    <br />
                    <span style="padding-left: 30px;">
                      👄 เลือกชุดที่ต้องการลองได้ 3ชุด ค่ะ
                    </span>
                    <br />
                    <span style="padding-left: 30px;">
                      👄 เลือกชุดที่ต้องการเช่าไว้ที่เหลือฝากแมสกลับทันทีค่ะ
                    </span>
                    <br />
                  </div>
                </div>

                <div class="toggle faq faq-marketplace faq-authors">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i
                    >5.หากส่งคืนล่าช้ากว่ากำหนด ทางร้านมีค่าใช้จ่ายเพิ่มมั้ยคะ ?
                  </div>
                  <div class="togglec">
                    💓กรณีคืนล่าช้า ไม่แจ้งล่วงหน้า ขออนุญาตปรับ 25%
                    ต่อวันของราคาเช่า ( ชุด Brand hi-end จะอีกเรทนึง)
                    หรือตามที่ทางร้านเห็นสมควร
                    เนื่องจากทางร้านเกิดความเสียหายจากการที่มีลูกค้าจองชุดต่อหรืออื่นๆ
                  </div>
                </div>

                <div class="toggle faq faq-affiliates faq-miscellaneous">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i
                    >6.คืนเงินประกันเมื่อไรหลังจากส่งชุดคืน ?
                  </div>
                  <div class="togglec">
                    เมื่อคุณลูกค้าส่งคืนชุดและทางร้านตรวจสอบว่าไม่มีการชำรุด
                    เสียหาย ฝ่ายบัญชีโอนเงินคืนประกัน 1-3 วัน หลังคืนชุดค่ะ
                    <br /><br />
                    🧨 ฝ่ายบัญชี ทำงาน 9.00-18.00 น . หยุดทุกวันจันทร์
                    เงินมัดจำจะคืนในช่วงเวลาที่ฝ่ายบัญชีทำงานเท่านั้นค่ะ
                  </div>
                </div>

                <div class="toggle faq faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>7.
                    ลูกค้าต้องทำความสะอาดชุดก่อนส่งคืนมั๊ยคะ ?
                    เมื่อใช้เสร็จแล้วสามารถนำส่งคืนได้เลยค่ะ ไม่ต้องทำความสะอาด
                    ทางร้านบริการซักทำความสะอาดให้ทั้งก่อนรับไปและส่งคืนค่ะ
                    (ไม่มีค่าใช้จ่ายเพิ่มเติมในส่วนนี้ค่ะ )
                  </div>
                  <div class="togglec">
                    ทำความสะอาดเฉพาะชุดว่ายน้ำค่ะ 👙<br /><br />
                    หลังใช้ชุดว่ายน้ำเสร็จแล้วกรุณาปฏิบัติดังนี้<br />
                    💋
                    นำชุดว่ายน้ำไปแช่ในน้ำสะอาดอุณหภูมิปกติและบีบน้ำออกอย่างเบามือ
                    ทำซ้ำ 3 – 4 ครั้ง หรือล้างด้วยน้ำสบู่อ่อนๆ
                    แช่และบีบอย่างเบามือในน้ำแรก และล้างด้วยน้ำสะอาดอีก 3 – 4
                    รอบ <br />
                    💋 ที่สำคัญมากคือ ห้ามซักชุดว่ายน้ำด้วยน้ำอุ่น ห้ามขยี้
                    ห้ามบิดผ้าเด็ดขาด ห้ามใช้ผงซักฟอก ห้ามนำเข้าเครื่องซักผ้า<br />

                    💋 กลับเอาด้านในออก ตากแดดอ่อนๆ หรือในร่มจนแห้งสนิท<br />

                    💋 ใส่ถุงซิปช็อค ส่งกลับคืนทางร้าน<br /><br />
                    ‼️‼️ หากคุณลูกค้าไม่ได้ปฏิบัติตาม แล้วชุดเกิดความเสียหาย
                    จะมีค่าปรับตามความเหมาะสมค่ะ ‼️‼️
                  </div>
                </div>
                <div class="toggle faq faq-legal faq-itemdiscussion">
                  <div class="togglet">
                    <i class="toggle-closed icon-comments-alt"></i>
                    <i class="toggle-open icon-comments-alt"></i>8.
                    หากชุดเสียหาย ปรับอย่างไรคะ?
                  </div>
                  <div class="togglec">
                    💗เมื่อรับชุดไปแล้วให้ลูกค้าตรวจเช็คก่อนใส่
                    หากพบว่าชุดมีความเสียหายอันไม่ได้เกิดจากลูกค้า
                    ให้รีบแจ้งทางร้านให้ทราบเพื่อหลีกเลี่ยงการโดนปรับค่าประกันค่ะ
                    กรณีมีรอยเลอะที่สามารถส่งซักออกได้
                    หรือชุดเกิดการชำรุดเพียงเล็กน้อยและซ่อมแซมได้
                    ทางร้านไม่หักค่าประกันชุดค่ะ
                    <br /><br />
                    ถ้ากรณีที่ชุดเลอะเยอะมากเป็นรอยหนักหรือไม่สามารถซักออกได้
                    รวมถึงชุดได้รับความเสียหายมาก
                    ทางร้านขออนุญาตปรับจากเงินประกัน
                    ตามมูลค่าความเสียหายที่ทางร้านเห็นสมควรค่ะ
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ROW -->
          <!-- .postcontent end -->
        </div>
      </div>
    </section>
    <!-- #content end -->
  </div>
</template>
<script>
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {
      welcome: "This is your profile",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    welcomeMessage() {},
  },
  components: {},
};
</script>

<style>
.toggle {
  text-align: left;
}
.togglec {
  text-align: left;
}

.faq_title {
  font-size: 48px;
  font-weight: 500;
  padding-left: 120px;
  text-align: left;
  padding-bottom: 60px;
  padding-top: 50px;
}

@media only screen and (max-width: 578px) {
  .faq_title {
    font-size: 36px !important;
    font-weight: 500;
    padding-left: 10px !important;
    text-align: left;
    padding-bottom: 60px;
    padding-top: 50px;
  }
}
</style>